import { MaterialFamily } from '../types';

export const DEFAULT_COLORS: Record<MaterialFamily, { inside: string; outside: string }> = {
  [MaterialFamily.WOOD]: { inside: '#c4a882', outside: '#c4a882' },
  [MaterialFamily.UPVC]: { inside: '#ffffff', outside: '#ffffff' },
  [MaterialFamily.ALUMINIUM]: { inside: '#8a8a8a', outside: '#3a3a3a' },
  [MaterialFamily.STEEL]: { inside: '#2a2a2a', outside: '#2a2a2a' },
  [MaterialFamily.WOOD_ALU]: { inside: '#c4a882', outside: '#3a3a3a' },
};

export const MATERIAL_ROUGHNESS: Record<MaterialFamily, number> = {
  [MaterialFamily.WOOD]: 0.65,
  [MaterialFamily.UPVC]: 0.35,
  [MaterialFamily.ALUMINIUM]: 0.15,
  [MaterialFamily.STEEL]: 0.10,
  [MaterialFamily.WOOD_ALU]: 0.15,
};

export const MATERIAL_METALNESS: Record<MaterialFamily, number> = {
  [MaterialFamily.WOOD]: 0.0,
  [MaterialFamily.UPVC]: 0.0,
  [MaterialFamily.ALUMINIUM]: 0.9,
  [MaterialFamily.STEEL]: 0.95,
  [MaterialFamily.WOOD_ALU]: 0.9,
};

export const HANDLE_FINISH_COLORS: Record<string, string> = {
  chrome: '#c0c0c0',
  black: '#1a1a1a',
  white: '#f5f5f5',
  'brushed-steel': '#8a8a8a',
};
